export const LEGACY_CLAIM_STATUSES = [
  'Submitted',
  'In review',
  'More information needed',
  'Pending final review',
  'Review complete',
  'Payment pending',
  'Complete',
  'Denied',
  'Canceled',
] as const;

export const NEW_CLAIM_STATUSES = [
  'Submitted',
  'In review',
  'Requires more information',
  'Paid',
  'Denied (conditions not met)',
  'Cancelled by operator',
  'No coverage',
] as const;

export type LegacyClaimStatus = (typeof LEGACY_CLAIM_STATUSES)[number];
export type NewClaimStatus = (typeof NEW_CLAIM_STATUSES)[number];
export type ClaimStatus = LegacyClaimStatus | NewClaimStatus;

export const ALL_CLAIM_STATUSES: readonly ClaimStatus[] = [
  ...LEGACY_CLAIM_STATUSES,
  ...NEW_CLAIM_STATUSES.filter(
    (status): status is Exclude<NewClaimStatus, LegacyClaimStatus> =>
      !LEGACY_CLAIM_STATUSES.includes(status as LegacyClaimStatus),
  ),
];

/** Statuses for which no further claim payment is expected. */
export const TERMINAL_CLAIM_STATUSES: ReadonlySet<ClaimStatus> = new Set([
  'Complete',
  'Denied',
  'Canceled',
  'Paid',
  'Denied (conditions not met)',
  'Cancelled by operator',
  'No coverage',
]);

/** Terminal statuses displayed as grey progress segments. */
export const TERMINAL_NEGATIVE_CLAIM_STATUSES: ReadonlySet<ClaimStatus> = new Set([
  'Denied',
  'Canceled',
  'Denied (conditions not met)',
  'Cancelled by operator',
  'No coverage',
]);

/** Only settled, successful claims may display payout details. */
export const PAYMENT_BREAKDOWN_CLAIM_STATUSES: ReadonlySet<ClaimStatus> = new Set([
  'Complete',
  'Paid',
]);
